import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const Help = lazyWithRetry(() => import(/* webpackChunkName: "help" */'../../component/Help'))

const HelpPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<Help />
		</Suspense>
	)
})

HelpPage.displayName = 'HelpPage'
export default HelpPage
